module.exports = __webpack_public_path__ + "78bd2fdb3170ed22afe6ba98bf6b0a27.svg";